var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop } from 'vue-property-decorator';
import VueDialog from '../../../interface/IVueDialog';
import GoodsBatchService from '../../../api/GoodsBatchService';
import { Loading } from 'element-ui';
var BatchDialog = (function (_super) {
    __extends(BatchDialog, _super);
    function BatchDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.good = {};
        _this.listData = [];
        _this.stockVisible = false;
        return _this;
    }
    BatchDialog.prototype.created = function () {
        this.service = GoodsBatchService.getInstance();
    };
    BatchDialog.prototype.submit = function () {
        var _this = this;
        this.$validator.validateScopes().then(function (res) {
            if (!res)
                return _this.$message.error('本次发货最多支持四位小数，且不能超出库存数量');
            var list = _this.listData.filter(function (item) { return item.order_detail_oamount; });
            _this.currentRow.batch_list = list;
            _this.$emit('onSubmit', _this.currentRow);
            _this.stockVisible = false;
        });
    };
    BatchDialog.prototype.changeGoodRow = function (row, type) {
        if (type === 'order_detail_oamount') {
            row.out_storage_amount =
                Math.floor(row.order_detail_oamount * this.good.sales_unit_coefficient * 10000) / 10000;
        }
    };
    BatchDialog.prototype.blurGoodRow = function (row, type) {
        if (type === 'order_detail_oamount') {
            row.order_detail_oamount = Number(row.order_detail_oamount);
        }
    };
    BatchDialog.prototype.show = function (row, goods_format_id) {
        var _this = this;
        this.currentRow = row;
        this.currentRow.old_order_detail_oamount = row.order_detail_oamount;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_detail_id: row.order_detail_id || row.delivery_order_detail_id,
            type: this.handleStatus === 1 ? 2 : 1,
        };
        if (this.handleStatus === 2) {
            params.out_depot_id = row.out_depot_id;
            params.goods_format_id = goods_format_id || row.goods_format_id;
        }
        this.service
            .getGoodsBatchList(params)
            .then(function (res) {
            loadingInstance.close();
            var DATA = res.data.data;
            _this.good = DATA.goods;
            var list = DATA.list;
            list.map(function (item) {
                var batchItem = undefined;
                if (row.batch_list && row.batch_list.length)
                    batchItem = row.batch_list.find(function (BItem) { return BItem.production_date == item.production_date; });
                if (batchItem) {
                    item.order_detail_oamount = batchItem.order_detail_oamount || 0;
                    item.out_storage_amount = Math.floor(item.order_detail_oamount * _this.good.sales_unit_coefficient * 10000) / 10000;
                }
                else {
                    item.order_detail_oamount = item.order_detail_oamount || 0;
                    item.out_storage_amount = item.out_storage_amount || 0;
                }
                return item;
            });
            _this.listData = list;
            _this.stockVisible = true;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    __decorate([
        Prop({
            default: 1,
        })
    ], BatchDialog.prototype, "handleStatus", void 0);
    BatchDialog = __decorate([
        Component
    ], BatchDialog);
    return BatchDialog;
}(VueDialog));
export default BatchDialog;
